import { postToParent } from "@/iframe/session";

function debounce<T extends (...args: never[]) => void>(fn: T, ms: number): T {
  let timer: ReturnType<typeof setTimeout> | undefined;
  return ((...args: never[]) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), ms);
  }) as T;
}

export function observeAndReportSize(el: HTMLElement): () => void {
  if (window.parent === window) return () => {};
  if (typeof ResizeObserver === "undefined") return () => {};

  const post = debounce((heightPx: number) => {
    postToParent({ version: 1, type: "account-mgt:resize", payload: { heightPx } });
  }, 100);

  const ro = new ResizeObserver((entries) => {
    const entry = entries[0];
    if (!entry) return;
    post(Math.ceil(entry.contentRect.height));
  });

  ro.observe(el);
  return () => ro.disconnect();
}
